import { Route } from 'react-router-dom';

import { Attributes } from './attributes/attributes.component';
import { Categories } from './categories';
import { Kits } from './kits/kits.component';
import { Products } from './products/products.component';

export function ApplicationsCatalogueRoutes() {
    return (
        <Route path='catalogue'>
            <Route
                path='products'
                element={<Products />}
            />
            <Route
                path='attributes'
                element={<Attributes />}
            />
            <Route
                path='categories'
                element={<Categories />}
            />
            <Route
                path='kits'
                element={<Kits />}
            />
        </Route>
    );
}
